import { ActivatedRoute } from '@angular/router';

export function getParamFromActivatedRoute(routes: ActivatedRoute, param: string): string {
    if (routes.snapshot.paramMap.has(param)) {
        return routes.snapshot.paramMap.get(param);
    }
    return '';
}

export function getQueryParamFromActivatedRoute(routes: ActivatedRoute, param: string): string {
    // if (routes.snapshot.queryParams.has(param)) {
        return routes.snapshot.queryParams[param] || '';
    // }
    // return '';
}
